module.exports = __webpack_public_path__ + "img/bank_21.4f474922.png";